<h4 mat-dialog-title>
  <span *ngIf="!data;else editHeader">
    Creazione nuova modello compagnia
  </span>
  <ng-template #editHeader>
    Modifica Modello compagnia
  </ng-template>
</h4>

<form [formGroup]="form" class="mt-4" (keydown.enter)="edit()">
    
    <mat-form-field>
      <mat-label>Compagnia</mat-label>
      <compagnia-picker formControlName="compagnia"></compagnia-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        Nome condizione
      </mat-label>
      <input matInput formControlName="nome_condizione">
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        Codice modello
      </mat-label>
      <input matInput formControlName="cod_modello">
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        Edizione
      </mat-label>
      <input matInput formControlName="edizione">
    </mat-form-field>

    <mat-form-field class="pb-3">
      <ngx-mat-file-input formControlName="nome_file"  placeholder="File">
      </ngx-mat-file-input>
      <mat-icon matSuffix>folder</mat-icon>
    <mat-hint *ngIf="nome">File caricato: {{ nome }}</mat-hint>
    </mat-form-field>
    
</form>
<button mat-raised-button (click)="edit()" color="primary">Salva</button>